import template from './survey_results_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class SurveyResultsHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class SurveyResultsHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new SurveyResultsHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'SurveyResultsHelp',
	dialog_class: SurveyResultsHelpPage,
	template: template,
	template_filename: 'translation/dialogs/survey_results_help',
	provider: 'ps'
};
